module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou15-60df460565063d24c7c20f6eb755677c.jpg";